export default "__VITE_ASSET__D4SI41kK__"